module.exports = __webpack_public_path__ + "img/ico-close-edit.5fbc1c53.svg";